import { render, staticRenderFns } from "./bianma.vue?vue&type=template&id=48a83a2c&scoped=true"
import script from "./bianma.vue?vue&type=script&lang=js"
export * from "./bianma.vue?vue&type=script&lang=js"
import style0 from "./bianma.vue?vue&type=style&index=0&id=48a83a2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a83a2c",
  null
  
)

export default component.exports